.appLinks {
  display: none;
}
@media (max-width: 768px) {
  .appLinks {
    margin-block-start: var(--app-links-margin-block-start, var(--cxy-spacing-3));
    display: flex;
    gap: var(--cxy-spacing-xxsm);
  }
  .appLinks > a,
  .appLinks img {
    height: 40px;
  }
}
